import { ref } from 'vue'
import { auth, createUserWithEmailAndPassword, updateProfile } from '@/firebase/config'

// refs & signup outside of exported function
// they don't need to be re-created every time we invoke useSignup
const error = ref(null)

const signup = async (email, password, displayName) => {
  error.value = null

  createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
    // Signed in
      updateProfile(userCredential.user, {
        displayName
      }).then(() => {
      // Profile updated!
      // ...
      }).catch((error) => {
      // An error occurred
        throw new Error('Could not complete update' + error)
      })
      return userCredential.user
    })
    .catch((error) => {
      const errorCode = error.code
      error.value = errorCode + error.message
    // ..
    })
}
// Call updateUser.js
const useSignup = () => {
  return { error, signup }
}

export default useSignup
